import { render } from "./Islands.vue?vue&type=template&id=ba537058&scoped=true"
import script from "./Islands.vue?vue&type=script&lang=js"
export * from "./Islands.vue?vue&type=script&lang=js"

import "./Islands.vue?vue&type=style&index=0&id=ba537058&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba537058"]])

export default __exports__